import React, { Fragment } from 'react';
import moment from 'moment';

import { getUserUrl } from '../utilities/urlHelper';
import { canDeleteComment, canMarkAnswer } from '../utilities/permissionsUtilities';
import contentToEditorState from '../tettra-editor/utilities/contentToEditorState';
import { sanitizeHTML } from '../utilities/sanitizeHTML';

import TettraEditor from '../tettra-editor/components/TettraEditor';
import AuthorAvatar from './page/AuthorAvatar';

import useUser from '../hooks/useUser';

const READ_ONLY = true;

const CommentBody = ({ comment }) => {
    if (!comment.content_state) {
        const sanitizedHtml = sanitizeHTML(comment.comment);
        return <div className="post-comment-html" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
    }

    return (
        <TettraEditor
            config={{
                editorIdentifier: 'CommentShow',
                readOnly: READ_ONLY,
                enableSmallEditor: true,
            }}
            editorState={contentToEditorState(JSON.parse(comment.content_state), READ_ONLY)}
            updateModel={() => null}
        />
    );
};

const CommenterName = ({ userId }) => {
    const user = useUser(userId);
    if (!user) return null;

    let displayName = user.display_name;
    if (user.deactivated_at) displayName += ' (Deactivated)';

    return (<a href={getUserUrl(userId)} className="commenter">{displayName}</a>);
};

const CommentDropDown = ({ comment, deleteComment, markAsAnswer }) => {
    const canDelete = canDeleteComment() || window.userId === comment.user_id;

    if (!markAsAnswer) {
        return (
            <Fragment>
                { canDelete
                && <span className="comment-action-button red right" onMouseDown={() => deleteComment(comment.id)}>Delete</span>}
            </Fragment>
        );
    }

    const showDropDown = canMarkAnswer() || canDelete;

    if (!showDropDown) return null;

    return (
        <div className="dropdown dropdown-right-aligned right comment-dropdown">
            <button className="content-action-button dropdown-link dropdown-elipsis" type="button">
                <img className="button-icon" height="18" width="4" src="/img/icons/dropdown-elipsis.svg" />
            </button>
            <div className="dropdown-overlay" style={{ display: 'none' }} />
            <div className="dropdown-content no-select" style={{ display: 'none' }}>
                {canMarkAnswer() && <span className="dropdown-option" onMouseDown={() => markAsAnswer(comment)}>Mark as answer</span>}
                {canDelete && <span className="dropdown-option red" onMouseDown={() => deleteComment(comment.id)}>Delete comment</span>}
                <a className="dropdown-option do-cancel">Cancel</a>
            </div>
        </div>
    );
};

const Comment = ({
    comment, deleteComment, markAsAnswer, isReadOnly = false,
}) => {
    const time = moment.utc(comment.created_at);

    if (isReadOnly) {
        return (
            <div className="post-comment" id={`comment-${comment.id}`}>
                <div className="flex-none">
                    <AuthorAvatar customClass="post-comment-avatar" customLinkClass="" userId={comment.user_id} tooltip="Comment from" />
                </div>
                <div className="post-comment-content">
                    <div className="post-comment-meta">
                        <CommenterName userId={comment.user_id} />
                        <a href={`#comment-${comment.id}`} title={time.local().toString()} className="post-comment-time gray">{time.fromNow()}</a>
                    </div>
                    <CommentBody comment={comment} />
                </div>
            </div>
        );
    }

    return (
        <div className="post-comment" id={`comment-${comment.id}`}>
            <div className="flex-none">
                <AuthorAvatar customClass="post-comment-avatar" customLinkClass="" userId={comment.user_id} tooltip="Comment from" />
            </div>
            <div className="post-comment-content">
                <div className="post-comment-meta">
                    <CommenterName userId={comment.user_id} />
                    <a href={`#comment-${comment.id}`} title={time.local().toString()} className="post-comment-time gray">{time.fromNow()}</a>
                    <CommentDropDown comment={comment} deleteComment={deleteComment} markAsAnswer={markAsAnswer} />
                </div>
                <CommentBody comment={comment} />
            </div>
        </div>
    );
};

export default Comment;
